export const HOMA_DISCORD_CHANNEL_URL = "https://discord.com/channels/951112968920244275/951476720509263914";